import { Link, useParams } from 'react-router-dom'
import { Section, SectionHeading, SplitHero, CheckItem, FAQ, CTABand, NonMedicalNote } from '../components/ui'
import { PHONE_DISPLAY, PHONE_TEL } from '../lib/constants'
import { services } from '../data/services'

export default function ServiceDetail({ specialized = false }) {
  const { slug } = useParams()
  const service = services[slug]

  if (!service || service.specialized !== specialized) {
    return (
      <Section tone="panel" hero>
        <SectionHeading
          eyebrow="Not found"
          title="We couldn't find that service"
          lede="The page you're looking for doesn't exist or may have moved."
        />
        <div style={{ marginTop: 32 }}>
          <Link to="/services" className="link-inline">Browse all services</Link>
        </div>
      </Section>
    )
  }

  return (
    <>
      <SplitHero
        eyebrow={service.eyebrow}
        title={service.title}
        lede={service.lede}
        image={service.image}
        imageAlt={service.imageAlt}
        actions={
          <>
            <Link to="/schedule-assessment" className="btn btn-primary">Schedule an In-Home Assessment</Link>
            <a href={PHONE_TEL} className="btn btn-secondary">Call {PHONE_DISPLAY}</a>
          </>
        }
      />

      {/* What's included */}
      <Section tone="white">
        <SectionHeading title="What's included" lede={service.includedLede} />
        <div style={{ marginTop: 48 }}>
          <div className="grid grid-2" style={{ gap: 16, maxWidth: 920, width: '100%' }}>
            {service.included.map((item) => <CheckItem key={item}>{item}</CheckItem>)}
          </div>
        </div>
      </Section>

      {/* Info card pair + non-medical note */}
      <Section tone="panel">
        <div className="grid grid-2" style={{ gap: 32 }}>
          {service.cards.map((card) => (
            <div
              key={card.title}
              style={{
                display: 'flex',
                height: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                flexDirection: 'column',
                borderRadius: 8,
                border: '1px solid var(--color-line)',
                borderTop: '4px solid var(--color-sage)',
                background: '#FFFFFF',
                padding: 32,
                boxShadow: 'var(--shadow-soft)',
              }}
            >
              <h3 style={{ margin: 0, fontSize: '1.5rem', lineHeight: 1.2, color: 'var(--color-teal-900)' }}>{card.title}</h3>
              <p style={{ margin: '16px 0 0 0', fontSize: 19, lineHeight: 1.7, color: 'var(--color-muted)' }}>{card.body}</p>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 48 }}>
          <NonMedicalNote />
        </div>
      </Section>

      {/* Works well with */}
      <Section tone="cream">
        <h3 style={{ margin: 0, fontSize: '1.5rem', lineHeight: 1.2, color: 'var(--color-teal-900)' }}>Works well with</h3>
        <div style={{ marginTop: 24, display: 'flex', flexWrap: 'wrap', gap: 16 }}>
          {service.worksWellWith.map((w) => (
            <Link key={w.to} to={w.to} className="btn btn-secondary">{w.label}</Link>
          ))}
        </div>
      </Section>

      {/* FAQ */}
      <Section tone="cream">
        <FAQ items={service.faqs} />
      </Section>

      <CTABand />
    </>
  )
}
